import { AlertCircle, RefreshCw } from "lucide-react";

import { Skeleton } from "shared/ui/shadcn/skeleton";
import { Button } from "shared/ui/shadcn/button";

interface BookedMeetingCalendarEventSectionStatesPropsI {
  onRetry: () => void;
}

const PendingSkeletonSection = () => (
  <div className="flex gap-2">
    <Skeleton className="h-10 w-10 rounded-full" />
    <div className="flex flex-1 flex-col gap-1">
      <Skeleton className="h-3 w-32" />
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-3 w-20" />
    </div>
  </div>
);

export const BookedMeetingCalendarEventSectionStates = {
  Pending: () => (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-32" />
      </div>

      <div className="flex flex-col gap-2">
        <Skeleton className="h-4 w-16" />
        <div className="flex flex-col gap-2">
          <PendingSkeletonSection />
          <PendingSkeletonSection />
        </div>
      </div>

      <Skeleton className="h-3 w-48" />
    </div>
  ),
  Error: ({ onRetry }: BookedMeetingCalendarEventSectionStatesPropsI) => (
    <div className="flex flex-col items-center justify-center gap-3 py-8">
      <AlertCircle className="h-10 w-10 text-red-500" />
      <div className="flex flex-col items-center gap-1">
        <h4 className="text-center typography-body-3-semibold">
          Failed to load calendar event
        </h4>
        <span className="max-w-[280px] text-center text-black/60 typography-body-4">
          We couldn't retrieve the calendar event details. Please try again.
        </span>
      </div>
      <Button onClick={onRetry} variant="outline" size="sm">
        <RefreshCw className="mr-2 h-4 w-4" />
        Retry
      </Button>
    </div>
  ),
};
